import React from 'react';

const ShowViewTitle = ({ record }) => {
  return <span>{record ? record.name : ''}</span>;
};

export default ShowViewTitle;